import {
    attachmentsDelete,
    createPipelineStage,
    createSimpleTask,
    createTask,
    createWorkflow,
    deletePipelineStage,
    deleteTask,
    deleteWorkflow,
    doneTask,
    getAllWorkFlows,
    getListDoneTask,
    getListTasks,
    getTaskDetail,
    getTaskListByDate,
    getTasks,
    getWorkflowDetails,
    getWorkflowPipelines,
    multipleTaskDelete,
    multipleTaskMove,
    updatePipelinePosition,
    updatePipelineStage,
    updateTask,
    updateTaskPosition,
    updateWorkflow,
} from "../../api/tasks";

const tasks = {
    namespaced: true,
    state: {
        defaultWorkflow: {},
        tasks: {},
        workflows: [],
        basicTaskForm: {},
        checkedTasks: {},
    },
    getters: {},
    mutations: {
        SET_WORKFLOWS: (state, payload) => {
            state.workflows = payload;
        },
        SET_DEFAULT_WORKFLOW: (state, payload) => {
            state.defaultWorkflow = payload;
        },
        SET_TASKS: (state, payload) => {
            state.tasks = payload;
        },
        CLEAR_TASKS: (state) => {
            state.tasks = {};
        },
        SET_BASIC_TASK_FORM: (state, form) => {
            state.basicTaskForm = form;
        },
        SET_CHECKED_TASKS: (state, checkedItems) => {
            state.checkedTasks = checkedItems;
        },
    },
    actions: {
        async getAllWorkFlows({ commit, dispatch }) {
            const workflows = await getAllWorkFlows().then((res) => res.data);
            const defaultWorkflow = workflows.find((workflow) => workflow.default);
            commit("SET_WORKFLOWS", workflows);
            dispatch("setDefaultWorkflows", defaultWorkflow);
            return workflows;
        },
        clearTasks({ commit }) {
            commit("CLEAR_TASKS");
        },
        getWorkflowPipelines({ commit }, workflowId) {
            return getWorkflowPipelines(workflowId);
        },
        getPaginationTasks({ commit, state }, params) {
            return getTasks(params.workflowId, params.pipelineId, params.page, params.perPage)
                .then((res) => res.data)
                .then((body) => {
                    commit(
                        "SET_TASKS",
                        Object.keys(state.tasks).reduce((acc, pipelineId) => {
                            acc[pipelineId] = [...(state.tasks[pipelineId] || []), ...(body[pipelineId] || [])];
                            return acc;
                        }, {})
                    );
                    return body;
                });
        },
        getTasks({ commit }, params) {
            return getTasks(params.workflowId, params.pipelineId, params.assignees, params.page, params.perPage)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", body);
                    return body;
                });
        },
        updateTaskPosition({ commit, state }, params) {
            return updateTaskPosition(params.taskId, params.payload).then((req) => {
                commit(
                    "SET_TASKS",
                    params.groups.reduce((acc, pipeline) => {
                        acc[pipeline._id] = pipeline.tasks;
                        return acc;
                    }, [])
                );
                const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                    pl.taskCount = state.tasks[pl._id]?.length || 0;
                    return pl;
                });
                commit(
                    "SET_WORKFLOWS",
                    state.workflows.map((wf) => {
                        if (wf._id === state.defaultWorkflow._id)
                            wf = {
                                ...state.defaultWorkflow,
                                pipeline,
                            };

                        return wf;
                    })
                );
            });
        },
        updatePipelinePosition({ commit }, params) {
            return updatePipelinePosition(params.workflowId, params.pipelineId, params.position);
        },
        setWorkflows({ commit }, data) {
            commit("SET_WORKFLOWS", data);
        },
        setDefaultWorkflows({ commit, dispatch }, data) {
            commit("SET_DEFAULT_WORKFLOW", data);
        },
        deleteTask({ commit, state }, task) {
            return deleteTask(task._id)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", {
                        ...state.tasks,
                        [task.pipelineStage]: state.tasks[task.pipelineStage].filter((t) => t._id !== task._id),
                    });
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    return body;
                });
        },
        doneTask({ commit, state }, task) {
            return doneTask(task._id)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", {
                        ...state.tasks,
                        [task.pipelineStage]: state.tasks[task.pipelineStage].filter((t) => t._id !== task._id),
                    });
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    return body;
                });
        },
        createSimpleTask({ commit, state }, payload) {
            return createSimpleTask(payload)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", {
                        ...state.tasks,
                        [payload.pipelineStageId]: [body, ...(state.tasks[payload.pipelineStageId] || [])],
                    });
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    return body;
                });
        },
        createTask({ commit, state }, payload) {
            return createTask(payload)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", {
                        ...state.tasks,
                        [payload.pipelineStageId]: [body, ...(state.tasks[payload.pipelineStageId] || [])],
                    });
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    return body;
                });
        },
        createWorkflow({ commit, state }, payload) {
            return createWorkflow(payload)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_WORKFLOWS", [...state.workflows, body]);
                    return body;
                });
        },
        updateWorkflow({ commit, state }, payload) {
            return updateWorkflow(payload.workflowId, payload.params)
                .then((res) => res.data)
                .then((data) => {
                    if (data.default) {
                        commit("SET_DEFAULT_WORKFLOW", data);
                    }
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((workflow) => {
                            if (workflow._id === data._id) workflow = data;
                            return workflow;
                        })
                    );
                });
        },
        getTaskDetail({ commit }, taskId) {
            return getTaskDetail(taskId).then((res) => res.data);
        },
        updateTask({ commit, state }, payload) {
            return updateTask(payload.taskId, payload.params)
                .then((res) => res.data)
                .then((body) => {
                    commit("SET_TASKS", {
                        ...state.tasks,
                        [body.pipelineStage]: state.tasks[body.pipelineStage].map((task) => {
                            if (task._id === payload.taskId) task = body;
                            return task;
                        }),
                    });
                    return body;
                });
        },
        attachmentsDelete({ commit, state }, payload) {
            return attachmentsDelete(payload.taskId, payload.attachmentId);
        },
        createPipelineStage({ state, commit }, payload) {
            return createPipelineStage(state.defaultWorkflow._id, payload)
                .then((res) => res.data)
                .then((pipeline) => {
                    const defaultWorkflow = {
                        ...state.defaultWorkflow,
                        pipeline: state.defaultWorkflow.pipeline.map((p) => {
                            if (p.isNewColumn) {
                                p = {
                                    ...pipeline,
                                    tasks: [],
                                    taskCount: 0,
                                };
                            }
                            return p;
                        }),
                    };
                    const updatedWorkflows = state.workflows.map((workflow) => {
                        if (workflow._id === state.defaultWorkflow._id) workflow = defaultWorkflow;
                        return workflow;
                    });
                    commit("SET_WORKFLOWS", updatedWorkflows);
                    commit("SET_DEFAULT_WORKFLOW", defaultWorkflow);
                });
        },
        updatePipelineStage({ commit, state }, payload) {
            return updatePipelineStage(payload.pipelineId, payload.params);
        },
        getListTasks({}, payload) {
            return getListTasks(payload.assignees, payload.page, payload.perPage, payload.visitorId).then((res) => res.data);
        },
        getListDoneTask({}, payload) {
            return getListDoneTask(payload.workflowId, payload.page, payload.perPage).then((res) => res.data);
        },
        deletePipelineStage({ commit, state }, payload) {
            return deletePipelineStage(payload.pipelineId, payload.workflowId, payload.newTaskPositionId)
                .then((res) => res.data)
                .then((body) => {
                    const defaultWorkflow = {
                        ...state.defaultWorkflow,
                        pipeline: state.defaultWorkflow.pipeline.filter((p) => p._id !== payload.pipelineId),
                    };
                    const updatedWorkflows = state.workflows.map((workflow) => {
                        if (workflow._id === state.defaultWorkflow._id) workflow = defaultWorkflow;
                        return workflow;
                    });
                    if (payload.newTaskPositionId) {
                        commit("SET_TASKS", {
                            ...state.tasks,
                            [payload.pipelineId]: [],
                            [payload.newTaskPositionId]: [
                                ...state.tasks[payload.pipelineId],
                                ...(state.tasks[payload.newTaskPositionId] || []),
                            ],
                        });
                    }
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        updatedWorkflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    commit("SET_WORKFLOWS", updatedWorkflows);
                    commit("SET_DEFAULT_WORKFLOW", defaultWorkflow);
                    return body;
                });
        },
        getWorkflowDetails({ commit, state }, params) {
            return getWorkflowDetails(params.workflowId).then((res) => res.data);
        },
        setBasicTaskForm({ commit }, form) {
            commit("SET_BASIC_TASK_FORM", form);
        },
        setCheckedTasks({ commit }, items) {
            commit("SET_CHECKED_TASKS", items);
        },
        multipleTaskDelete({ state, commit }, taskIds) {
            return multipleTaskDelete(taskIds)
                .then((res) => res.data)
                .then((body) => {
                    commit(
                        "SET_TASKS",
                        _.groupBy(
                            Object.values(state.tasks)
                                .flat()
                                .filter((task) => !taskIds.includes(task._id)),
                            (task) => task.pipelineStage
                        )
                    );
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    commit("SET_CHECKED_TASKS", {});
                    return body;
                });
        },
        mulitpleTaskMove({ state, commit }, payload) {
            return multipleTaskMove(payload.pipelineId, payload.taskIds)
                .then((res) => res.data)
                .then(() => {
                    commit(
                        "SET_TASKS",
                        _.groupBy(
                            Object.values(state.tasks)
                                .flat()
                                .map((task) => {
                                    if (payload.taskIds.includes(task._id)) {
                                        task.pipelineStage = payload.pipelineId;
                                    }
                                    return task;
                                }),
                            (task) => task.pipelineStage
                        )
                    );
                    const pipeline = state.defaultWorkflow.pipeline.map((pl) => {
                        pl.taskCount = state.tasks[pl._id]?.length || 0;
                        return pl;
                    });
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.map((wf) => {
                            if (wf._id === state.defaultWorkflow._id)
                                wf = {
                                    ...state.defaultWorkflow,
                                    pipeline,
                                };

                            return wf;
                        })
                    );
                    commit("SET_CHECKED_TASKS", {});
                    return body;
                });
        },
        deleteWorkflow({ commit, state }, workflowId) {
            return deleteWorkflow(workflowId)
                .then((res) => res.data)
                .then((body) => {
                    commit(
                        "SET_WORKFLOWS",
                        state.workflows.filter((wf) => wf._id !== workflowId)
                    );
                    return body;
                });
        },
        getTaskListByDate({}, { userId, startDate, endDate }) {
            return getTaskListByDate(userId, startDate, endDate).then((res) => res.data);
        },
    },
};
export default tasks;
